<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Add Video Section</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>

  <form [formGroup]="addVideoSectionForm">
    <div class="form-row">
      <div class="col-md-12">
        <div class="form-group edit-video_form">

          <div class="form-row">
            <p class="edit-video_form_paragraph">If you have a <b>Youtube</b>, <b>Vimeo</b> or other link to a training video add it here.</p>
          </div>

          <div class="d-flex justify-content-start edit-video_form_url">
            <label class="edit-video_form_label">Video url </label>
            <input type="input" formControlName="video" class="form-control edit-video_form_input" name="video" id="video" placeholder="https://www..." />
          </div>

          <div class="form-row">
            <p class="edit-video_form_paragraph">If you have a video file and want <b>Skylark</b> to host it for you, please complete the rest of the Training Course and contact <a href="mailto:controlcentre@skylark.com">controlcentre@skylark.com</a> for assistance.</p>
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="d-flex justify-content-end">
    <button type="button" (click)="closeModal()" class="my-2 btn btn-round btn-sm btn-default">Cancel</button>
    <button type="button" [disabled]="!addVideoSectionForm.valid" (click)="submitVideoSection()" class="my-2 btn btn-round btn-sm btn-success">Save</button>
  </div>
</div>
